export const T = {
  en_GB: {
    title: "Import Products from CSV",
    description:
      "Upload a CSV with two columns: source (e.g. morningstar_funds) and id (the instrument ticker). Up to 500 rows per import.",
    chooseFile: "Choose CSV file",
    parseError: "Could not parse CSV",
    rowsParsed: "rows parsed",
    previewing: "Previewing first 10 rows",
    submit: "Start import",
    progress: "Progress",
    rowsProcessed: "processed",
    successCount: "succeeded",
    failedCount: "failed",
    perRowResults: "Per-row results",
    statusPending: "pending",
    statusProcessing: "processing",
    statusSuccess: "success",
    statusFailed: "failed",
    statusSkipped: "skipped (duplicate)",
    statusDone: "done",
    cancel: "Cancel",
    close: "Close",
    columnSource: "Source",
    columnId: "Id",
    columnStatus: "Status",
    columnError: "Error",
  },
  nb_NO: {
    title: "Importer produkter fra CSV",
    description:
      "Last opp en CSV med to kolonner: source (f.eks. morningstar_funds) og id (instrumentets ticker). Maks 500 rader per import.",
    chooseFile: "Velg CSV-fil",
    parseError: "Kunne ikke lese CSV",
    rowsParsed: "rader lest",
    previewing: "Viser de første 10 radene",
    submit: "Start import",
    progress: "Fremdrift",
    rowsProcessed: "behandlet",
    successCount: "vellykket",
    failedCount: "feilet",
    perRowResults: "Resultat per rad",
    statusPending: "venter",
    statusProcessing: "behandler",
    statusSuccess: "vellykket",
    statusFailed: "feilet",
    statusSkipped: "hoppet over (duplikat)",
    statusDone: "ferdig",
    cancel: "Avbryt",
    close: "Lukk",
    columnSource: "Kilde",
    columnId: "Id",
    columnStatus: "Status",
    columnError: "Feil",
  },
} as const;
